import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Alert,
  Box,
} from "@mui/material";
import AppHeader from "../components/AppHeader";
import { updateUser } from "../firebase";
import { useAuthUser } from "../hooks/useAuthUser";
import { useNavigate } from "react-router-dom";

const Edit = () => {
  const navigate = useNavigate();
  const { user, profile } = useAuthUser();
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");
  const [point, setPoint] = useState("");
  const [publishSuccess, setPublishSuccess] = useState(false);
  const [publishError, setPublishError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (profile) {
      setDisplayName(profile.displayName || "");
      setPhone(profile.phone || "");
      setPoint(profile.point || "");
    }
  }, [profile]);

  const handleSubmit = () => {
    if (!user) return;
    setLoading(true);
    setPublishError(null);
    updateUser(user.uid, displayName, phone, point)
      .then(() => {
        setPublishSuccess(true);
        setLoading(false);
        setTimeout(() => {
          navigate(-1);
        }, 1500);
      })
      .catch((error) => {
        console.error("Error updating user:", error);
        setPublishError(error.message || "No se pudo guardar los cambios.");
        setLoading(false);
      });
  };

  return (
    <Container disableGutters>
      <AppHeader variant="back" title="Editar perfil" user={user} />
      <Container sx={{ pt: 10, pb: 4, maxWidth: "sm" }}>
        <TextField
          label="Nombre"
          variant="outlined"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Teléfono"
          variant="outlined"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Localidad"
          variant="outlined"
          value={point}
          onChange={(e) => setPoint(e.target.value)}
          fullWidth
          margin="normal"
        />
        {publishError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {publishError}
          </Alert>
        )}
        {publishSuccess ? (
          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Typography>Cambios guardados correctamente.</Typography>
            <Button onClick={() => navigate(-1)} color="primary">
              Volver atrás
            </Button>
          </Box>
        ) : (
          <Button
            sx={{ mt: 2 }}
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Guardar cambios"}
          </Button>
        )}
      </Container>
    </Container>
  );
};

export default Edit;
